import { type Context } from '@databases/types/redux';
import { type AnyAction } from '@reduxjs/toolkit';

import contextSlice, { type ContextState } from './slice';

export interface ContextAppState {
  context: ContextState;
}

export const setContext = (context: Context): AnyAction =>
  contextSlice.actions.setContext(context);
